// Event emitted after snapchat bootstrap runs so late listeners can update identity safely.
export const SNAPCHAT_READY_EVENT = 'ft:snapchat-ready';
